import { render, staticRenderFns } from "./KSAllianceAuthorization.vue?vue&type=template&id=daff5d7a"
import script from "./KSAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./KSAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daff5d7a')) {
      api.createRecord('daff5d7a', component.options)
    } else {
      api.reload('daff5d7a', component.options)
    }
    module.hot.accept("./KSAllianceAuthorization.vue?vue&type=template&id=daff5d7a", function () {
      api.rerender('daff5d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/KSAllianceAuthorization.vue"
export default component.exports